import { Select as AntdSelect, SelectProps } from 'antd';
import styled, { css } from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px 4px;
  color: #333;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
`;

export const AccountMetricsPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 368px;
  height: calc(100% - 85px);
`;

export const AccountMetricsPanelContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  height: 100%;
  flex: 1;
`;

export const PanelGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
`;

export const PanelItemWrapper = styled.div<{ hoverable?: boolean; active?: boolean }>`
  display: flex;
  padding: 16px;
  height: 100%;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
  color: #4a4a4a;

  ${({ active }) =>
    active &&
    css`
      border: 1px solid #256eff;
    `}

  ${({ hoverable }) =>
    hoverable &&
    css`
      &:hover {
        cursor: pointer;
        background: #e5edff;
      }
    `}
`;

export const PanelItemTitle = styled.div`
  font-size: 16px;
  display: flex;
  gap: 4px;
`;

export const PanelItemContent = styled.div`
  font-size: 28px;
  color: #000;
`;

export const TableHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  height: 100%;
  gap: 4px;
`;

export const EmptyTableWrapper = styled.div`
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 24px;
`;

export const StyledSelect = styled(AntdSelect)<SelectProps>`
  width: fit-content;

  && .ant-select-selector {
    border: none;
    padding: 0 8px;

    .ant-select-selection-item {
      text-decoration: underline;
    }
  }
`;
